import { jsxs, jsx } from "react/jsx-runtime";
const STATUS_PILL = {
  placed: { label: "Order Placed", color: "#059669", bg: "#ECFDF5" },
  processing: { label: "Processing Order", color: "#D97706", bg: "#FFFBEB" },
  shipped: { label: "Shipped", color: "#2563EB", bg: "#EFF6FF" },
  out_for_delivery: { label: "Out For Delivery", color: "#2563EB", bg: "#EFF6FF" },
  delivered: { label: "Delivered", color: "#059669", bg: "#ECFDF5" },
  cancelled: { label: "Cancelled", color: "#DC2626", bg: "#FEF2F2" },
  returned: { label: "Returned", color: "#7C3AED", bg: "#F5F3FF" },
  unknown: { label: "Unknown", color: "#6B7280", bg: "#F9FAFB" }
};
function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
}
function formatAmount(amount) {
  return `$${amount.toFixed(2)}`;
}
const OrderListWidget = ({ data }) => {
  const { orders, total } = data;
  const extra = total - orders.length;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        width: "100%",
        maxWidth: 480,
        maxHeight: "100%",
        background: "var(--voice-widget-card-bg, #FFFFFF)",
        border: "1px solid var(--voice-widget-border, #E5E7EB)",
        borderRadius: 16,
        overflowY: "auto",
        boxShadow: "0 2px 12px rgba(0,0,0,0.07)"
      },
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              padding: "14px 18px 12px",
              borderBottom: "1px solid var(--voice-widget-border, #E5E7EB)"
            },
            children: [
              /* @__PURE__ */ jsx(
                "div",
                {
                  style: {
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: 0.5,
                    textTransform: "uppercase",
                    color: "var(--voice-widget-muted, #6B7280)"
                  },
                  children: "Recent Orders"
                }
              ),
              /* @__PURE__ */ jsxs("div", { style: { fontSize: 13, fontWeight: 600, color: "var(--voice-widget-fg, #111827)", marginTop: 2 }, children: [
                total,
                " order",
                total !== 1 ? "s" : ""
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsx("div", { children: orders.map((order, i) => {
          var _a, _b;
          const pill = STATUS_PILL[order.status] ?? STATUS_PILL.unknown;
          return /* @__PURE__ */ jsxs(
            "div",
            {
              style: {
                display: "flex",
                gap: 12,
                alignItems: "center",
                padding: "10px 18px",
                borderBottom: i < orders.length - 1 ? "1px solid var(--voice-widget-border, #E5E7EB)" : void 0
              },
              children: [
                ((_a = order.leadItem) == null ? void 0 : _a.imageUrl) ? /* @__PURE__ */ jsx(
                  "img",
                  {
                    src: order.leadItem.imageUrl,
                    alt: order.leadItem.title,
                    style: {
                      width: 40,
                      height: 40,
                      objectFit: "contain",
                      borderRadius: 6,
                      background: "var(--voice-widget-img-bg, #F9FAFB)",
                      flexShrink: 0
                    }
                  }
                ) : /* @__PURE__ */ jsx(
                  "div",
                  {
                    style: {
                      width: 40,
                      height: 40,
                      borderRadius: 6,
                      background: "var(--voice-widget-border, #E5E7EB)",
                      flexShrink: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 18,
                      color: "var(--voice-widget-muted, #6B7280)"
                    },
                    children: "📦"
                  }
                ),
                /* @__PURE__ */ jsxs("div", { style: { flex: 1, minWidth: 0 }, children: [
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      style: {
                        fontSize: 12,
                        fontWeight: 600,
                        color: "var(--voice-widget-fg, #111827)",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      },
                      children: ((_b = order.leadItem) == null ? void 0 : _b.title) ?? `Order #${order.retailerOrderId ?? order.orderId}`
                    }
                  ),
                  /* @__PURE__ */ jsxs("div", { style: { fontSize: 11, color: "var(--voice-widget-muted, #6B7280)", marginTop: 1 }, children: [
                    order.itemCount,
                    " item",
                    order.itemCount !== 1 ? "s" : "",
                    " · ",
                    formatDate(order.orderDate),
                    order.retailerName ? ` · ${order.retailerName}` : ""
                  ] })
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { textAlign: "right", flexShrink: 0 }, children: [
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      style: {
                        fontSize: 11,
                        fontWeight: 600,
                        color: pill.color,
                        background: pill.bg,
                        padding: "2px 8px",
                        borderRadius: 999,
                        display: "inline-block",
                        marginBottom: 3
                      },
                      children: pill.label
                    }
                  ),
                  /* @__PURE__ */ jsx("div", { style: { fontSize: 12, fontWeight: 700, color: "var(--voice-widget-fg, #111827)" }, children: formatAmount(order.totalAmount) })
                ] })
              ]
            },
            order.orderId
          );
        }) }),
        extra > 0 && /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              padding: "8px 18px",
              fontSize: 12,
              color: "var(--voice-widget-muted, #6B7280)",
              borderTop: "1px solid var(--voice-widget-border, #E5E7EB)",
              textAlign: "center"
            },
            children: [
              "+",
              extra,
              " more order",
              extra !== 1 ? "s" : "",
              " — ask me to look up specific ones"
            ]
          }
        )
      ]
    }
  );
};
export {
  OrderListWidget
};
//# sourceMappingURL=OrderListWidget.js.map
